<template>
  <div class="cell-style">
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "wrapperItemComertialReport"
};
</script>

<style scoped>
.cell-style {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.cell-style div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
